import styled, { css } from "styled-components";
import { Color, FontSize, Screen } from 'styles';
import { NavLink } from 'react-router-dom';

const MediumWrapperStyle = css`
  padding-top: ${props => props.isSubpage ? '80px' : '100px'};
`;
export const StyledWrapper = styled.section`
  background-color: ${Color.MediumGray};
  border-bottom: 6px solid ${Color.Black};
  padding-top: ${props=>props.isSubpage ? '225px' : '100px'};
  width: 100%;
  
  ${Screen.medium(MediumWrapperStyle)}
`;

const MediumProgramWrapper = css`
  padding-top: 33px;
`;

export const StyledProgramsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  padding: 73px 0 100px;
  
  ${Screen.medium(MediumProgramWrapper)}
`;

const MediumProgramsItemStyle = css`
  margin-right: 0;
`;

export const StyledProgramsItem = styled(NavLink)`
  border-left: 5px solid ${Color.Orange};
  border-bottom: 1px solid ${Color.Gray};

  background-color: ${Color.White};
  display: inline-block;
  margin: 0 25px 40px 0;
  transition: all 300ms ease-in-out;
  width: 100%;
  
  &:hover {
    border-left: 5px solid ${Color.Black};
    
    > div {
      background-color: ${Color.Black};
    }
    
    > div.program__description {
      background-color: ${Color.White};
    }
  }
  
  ${Screen.medium(MediumProgramsItemStyle)}
`;

export const StyledProgramHeader = styled.h3`
  color: ${Color.Orange};
  float: left;
  font-size: ${FontSize.M};
  padding: 32px 0 32px 24px;
  transition: all 300ms ease-in-out;
  text-align: left;
`;

export const StyledProgramNumber = styled.div`
  background-color: ${Color.Orange};
  color: ${Color.White};
  font-size: ${FontSize.M};
  float: right;
  transition: all 300ms ease-in-out;
  padding: 32px 32px;
`;

const MediumProgramDescriptionStyle = css`
  padding-right: 24px;
`;

export const StyledProgramDescription = styled.div`
  border-top: 1px solid ${Color.Gray};
  display: inline-block;
  width: 100%;
  padding: 29px 84px 29px 24px;
  text-align: left;
  
  ${Screen.medium(MediumProgramDescriptionStyle)}
`;


// WEBPACK FOOTER //
// ./src/components/about/about.style.js